import styled from 'styled-components';

import { size } from 'polished';

export const Line = styled.img`
    ${size('150px', '2px')}
`;
